<div class="signup-info-container">
  <div class="header">
    <img src="assets/logo/logo-full-green.png" alt="Check Plus Logo" class="logo" />
    <div class="back-link" (click)="goBack()">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="back-icon">
        <path d="M15.5 18L9.5 12L15.5 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span>Back to Home</span>
    </div>
  </div>

  <div class="form-content">
    <h1 class="title">Create an account</h1>
    <h2 class="subtitle">Enter Your Basic Info</h2>

    <form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="form">
      
      <!-- Company Name (Admin only) -->
      <div class="input-group" *ngIf="isAdmin">
        <label class="form-label">Company Name</label>
        <div class="input-wrapper">
          <input
            formControlName="companyName"
            placeholder="Enter company name"
            type="text"
            class="custom-input"
          />
        </div>
      </div>

      <!-- First Name -->
      <div class="input-group">
        <label class="form-label">First Name</label>
        <div class="input-wrapper">
          <input
            formControlName="firstName"
            placeholder="Enter your first name"
            type="text"
            class="custom-input"
          />
        </div>
      </div>

      <!-- Last Name -->
      <div class="input-group">
        <label class="form-label">Last Name</label>
        <div class="input-wrapper">
          <input
            formControlName="lastName"
            placeholder="Enter your last name"
            type="text"
            class="custom-input"
          />
        </div>
      </div>

      <!-- Password (Employee only) -->
      <ng-container *ngIf="!isAdmin">
        <div class="input-group">
          <label class="form-label">Password</label>
          <div class="input-wrapper">
            <input
              [type]="showPassword ? 'text' : 'password'"
              formControlName="password"
              placeholder="Enter Password"
              class="custom-input"
            />
            <mat-icon class="suffix-icon" (click)="showPassword = !showPassword">
              {{ showPassword ? 'visibility_off' : 'visibility' }}
            </mat-icon>
          </div>
          <label
            class="error-message"
            *ngIf="
              !form.controls['password'].valid &&
              form.controls['password'].touched
            "
          >
            {{ getPasswordErrorMessage('password') }}
          </label>
        </div>

        <div class="input-group">
          <label class="form-label">Confirm Password</label>
          <div class="input-wrapper">
            <input
              [type]="showConfirmPassword ? 'text' : 'password'"
              formControlName="confirmPassword"
              placeholder="Enter Confirm Password"
              class="custom-input"
            />
            <mat-icon class="suffix-icon" (click)="showConfirmPassword = !showConfirmPassword">
              {{ showConfirmPassword ? 'visibility_off' : 'visibility' }}
            </mat-icon>
          </div>
          <label
            class="error-message"
            *ngIf="
              !form.controls['confirmPassword'].valid &&
              form.controls['confirmPassword'].touched
            "
          >
            {{ getPasswordErrorMessage('confirmPassword') }}
          </label>
          <label
            class="error-message"
            *ngIf="
              form.controls['confirmPassword'].valid &&
              form.errors?.['mismatch'] &&
              form.controls['confirmPassword'].touched
            "
          >
            Passwords do not match.
          </label>
        </div>
      </ng-container>

      <button
        gbui-button
        type="submit"
        class="submit-button"
        [disabled]="form.invalid || isLoading"
        [busy]="isLoading"
        context="primary"
      >
        {{ isAdmin ? 'Submit' : 'Create account' }}
      </button>
    </form>
  </div>
</div>
